module.exports = "/img/videoIcon.5e69e8e5.png";